import styled from "styled-components";

export const NewDetailsTitle = styled.h1`
  color: var(--primary);
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0px;
`;

export const NewDetailsSubtitle = styled.h2`
  color: var(--neutral);
  font-size: 1.375rem;
  font-weight: 400;
  line-height: 1.4;
  margin: 16px 0;
`;

export const NewDetailsCategory = styled.span`
  display: inline-block;
  background: var(--primary);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const NewDetailsText = styled.div`
  font-weight: 300;
  font-size: 1.125rem;
  line-height: 1.8;
  color: var(--neutral);
  text-align: justify;
  margin-top: 24px;
  
  p {
    margin-bottom: 16px;
  }
  
  h1, h2, h3, h4, h5, h6 {
    color: var(--primary);
    margin: 24px 0 16px 0;
  }
`;

export const NewDetailsInfo = styled.p`
  font-weight: 300;
  font-size: 1rem;
  color: var(--neutral-light);
  margin: 8px 0;
  
  &:first-of-type {
    margin-top: 0;
  }
`;

export const NewDetailsImage = styled.img`
  width: 100%;
  object-fit: cover;
  height: auto;
  max-height: 600px;
  border-radius: 8px;
  margin: 24px 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;
